module.exports = __webpack_public_path__ + "media/apricot.2baa3740.wav";